import React from "react";
import { useHistory } from "react-router-dom";
import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import { UNIFIED_DASHBOARD_PATH } from "components/allInOneDashboard/constants/productRouteMap";

const BackToMainDashboard = ({ sx = {}, label = "Back to Explore" }) => {
  const history = useHistory();

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0.5}
      onClick={() => history.push(UNIFIED_DASHBOARD_PATH)}
      sx={{
        cursor: "pointer",
        width: "fit-content",
        mb: 1,
        "&:hover": { opacity: 0.75 },
        ...sx,
      }}
    >
      <ArrowBackOutlinedIcon sx={{ fontSize: 18, color: "#676E76" }} />
      <Text variant="small" sx={{ fontWeight: 500, color: "#676E76" }}>
        {label}
      </Text>
    </Stack>
  );
};

export default BackToMainDashboard;
